import { render, staticRenderFns } from "./TerminateApplyAudit.vue?vue&type=template&id=422e22a9&scoped=true"
import script from "./TerminateApplyAudit.vue?vue&type=script&lang=js"
export * from "./TerminateApplyAudit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422e22a9",
  null
  
)

export default component.exports